import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { MatSelectChange } from '@angular/material/select'
import { BeatsSortBy, FreeBeatsSortBy, SortBy } from '../../../enums/enums'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { FilterPropertyType } from '../../../types/filter.type'

@Component({
  selector: 'bmcore-sort-tracks-select',
  templateUrl: './bmcore-sort-tracks-select.component.html',
  styleUrls: ['./bmcore-sort-tracks-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreSortTracksSelectComponent implements OnInit {
  constructor(private i18nService: I18nService) {}

  @Input() isBeatmakerPage = false
  @Input() currentSortById: SortBy
  @Input() isFreeBeatsPage = false
  @Output() filterTracksEvent = new EventEmitter<FilterPropertyType>()

  lg: LgType

  protected readonly FreeBeatsSortBy = FreeBeatsSortBy
  protected readonly BeatsSortBy = BeatsSortBy

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
  }

  sortTracks(selectValue: MatSelectChange) {
    this.filterTracksEvent.emit({ title: 'sort-top-new', sort: selectValue.value })
  }
}
